import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { ImperiaUser, NavigationModel, PermissionModel } from '../models/navigation.model';
import { AuthService } from './auth.service';
import { getUserTypeFromName, UserType } from '../models/lynnco-admin/lynncobi-maintenance/user.model';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  private permissions: PermissionModel[];
  private userActions: string[];
  private userTypeName: string | null = null;
  
  constructor(private readonly apiService: ApiService, private readonly authService: AuthService) {
  }

  isReadOnly(viewKey: string, permsList: PermissionModel[] = this.permissions): boolean {
    let result = false;
    permsList.find(perm =>
      result = perm.viewKey === viewKey ? perm.readOnly : this.isReadOnly(viewKey, perm.children));
    return result;
  }

  getNavigation(): Observable<NavigationModel> {
    const userId = this.authService.userId;
    const url = `${environment.imperia.navigation}/${userId}`;
    return this.apiService.get<any>(url, {})
      .pipe(
        tap((response: any) => {
          this.permissions = response.data?.permissions;
          this.userActions = response.data?.actions || [];
          this.userTypeName = response.data?.typeName ?? null;
        }),
        map((response: any) => response.data)
      );
  }

  getAllUsers(): Observable<ImperiaUser[]> {
    return this.apiService.get<ImperiaUser[]>(environment.imperia.navigation);
  }

  hasAction(action: string): boolean {
    return this.userActions.includes(action);
  }

  getUserActions(): string[] {
    return this.userActions;
  }

  getUserType(): UserType | null {
    return getUserTypeFromName(this.userTypeName || '');
  }

}
